/**
 * The handoff contract between the booking app (nura.in / nurathailand.com)
 * and this app. This is the file the plan's §6/§9 calls for: one versioned
 * shape both repos read instead of each holding its own copy of the param
 * names and country-code format and silently drifting (see the plan's §1 —
 * the `p`/`data` param mismatch and the `IND`/`TH` format mismatch both
 * trace back to there being no shared source of truth for this).
 *
 * THIS FILE MUST BE MIRRORED IN THE BOOKING APP REPO. Until it's extracted
 * into a real shared package, treat a change here as a breaking change that
 * needs a matching change on that side — bump PAYLOAD_VERSION when the wire
 * shape changes, and update senders to stamp the new `v`.
 *
 * `useBookingSubmit`'s current payload (as reviewed) doesn't stamp `v` at
 * all — that's treated as legacy/v0 below and accepted, not rejected, until
 * the booking app is updated to send it. Once it does, LEGACY_UNVERSIONED
 * should be deleted from ACCEPTED_VERSIONS.
 */

export const PAYLOAD_VERSION = 1;
const LEGACY_UNVERSIONED = 0;
const ACCEPTED_VERSIONS: readonly number[] = [
  PAYLOAD_VERSION,
  LEGACY_UNVERSIONED,
];

/** Query params the booking app appends to the entry redirect. */
export const ENTRY_PARAMS = {
  orderId: 'payment_id',
  encryptedPayload: 'p',
} as const;

/**
 * The decrypted shape of `p`, exactly as the booking app sends it today.
 * `country` arrives as either `IND`/`TH` (legacy) or `IN`/`TH` (target) —
 * normalizeCountry() in countryConfig.ts is what reconciles that, not this
 * file, since this file's job is describing the wire shape, not fixing it up.
 */
export interface EntryPayload {
  v?: number;
  authToken: string;
  db_ptr: string;
  amount: number;
  country: string;
}

export function isSupportedPayloadVersion(payload: { v?: number }): boolean {
  return ACCEPTED_VERSIONS.includes(payload.v ?? LEGACY_UNVERSIONED);
}
